import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics } from './shared/analytics/ga4';

// MSAL Imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';

const msalInstance = new PublicClientApplication(msalConfig);
initializeAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initial Loading State
root.render(
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
    <h2 style={{ fontFamily: 'sans-serif', color: '#333' }}>Inicializando segurança...</h2>
  </div>
);

console.log("Starting MSAL Initialization...");

msalInstance.initialize()
  .then(() => {
    console.log("MSAL Initialized successfully.");
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch(e => {
    console.error("MSAL Initialization failed:", e);
    root.render(
      <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
        <h1 style={{ color: '#cc0000' }}>Erro de Inicialização</h1>
        <p>Não foi possível iniciar o sistema de autenticação.</p>
        <pre style={{ background: '#f0f0f0', padding: 10 }}>{e?.message || JSON.stringify(e)}</pre>
        <button onClick={() => window.location.reload()} style={{ padding: '10px 20px', cursor: 'pointer' }}>Tentar Novamente</button>
      </div>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
